// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mrs[data-v-802f2fd6]{ margin-right:5px;\n}\n.mls[data-v-802f2fd6]{ margin-left:5px;\n}\ndiv[data-v-802f2fd6]{\n\tfont-size: 13px; padding: 5px 20px 0 20px;\n\t-webkit-user-select: none;\n\t   -moz-user-select: none;\n\t    -ms-user-select: none;\n\t        user-select: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
